import { render, staticRenderFns } from "./carbonProfile.vue?vue&type=template&id=48beb0b6&scoped=true"
import script from "./carbonProfile.vue?vue&type=script&lang=js"
export * from "./carbonProfile.vue?vue&type=script&lang=js"
import style0 from "./carbonProfile.vue?vue&type=style&index=0&id=48beb0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48beb0b6",
  null
  
)

export default component.exports